// Scripts for the corporate-gifting flow (corporate-gifts page + cart footer)

window.CorpGifts = (function () {
  var COOKIE_NAME = 'corp-gift-user';
  var COOKIE_MAX_AGE_DAYS = 30;

  // Delegated binding, e.g. jQuery's $(document).on(eventType, selector, handler).
  // Fires for elements matching `selector` now or added later; `this` is the matched element.
  function on(eventType, selector, handler) {
    document.addEventListener(eventType, function (event) {
      var match = event.target.closest(selector);
      if (!match) return;
      handler.call(match, event);
    });
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + maxAge + '; path=/; SameSite=Lax';
  }

  function clearCookie(name) {
    document.cookie = name + '=; max-age=0; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  }

  function isCorpGiftsUser() {
    return getCookie(COOKIE_NAME) !== null;
  }

  // Bound to the "start a corporate order" button rendered by
  // sections/mpc-corp-gifts-info.liquid via this shared class hook.
  on('click', '.js-corp-gifts-start', function (event) {
    event.preventDefault();
    setCookie(COOKIE_NAME, Date.now(), COOKIE_MAX_AGE_DAYS);
    window.location.href = '/';
  });

  on('click', '.cart__blocks-standard-cta', function (event) {
    event.preventDefault();
    clearCookie(COOKIE_NAME);
    window.location.reload();
  });

  function toggleCartBlocksForCorpUser() {
    var defaultBlocks = document.querySelector('.cart__blocks-default');
    var corpActions = document.querySelector('.cart__blocks-corp-actions');
    var corpCta = document.querySelector('.cart__blocks-corp-cta');
    var standardCta = document.querySelector('.cart__blocks-standard-cta');
    if (!defaultBlocks && !corpActions && !corpCta && !standardCta) return;

    var isCorp = isCorpGiftsUser();
    if (defaultBlocks) defaultBlocks.hidden = isCorp;
    if (corpActions) corpActions.hidden = !isCorp;
    if (corpCta) corpCta.hidden = !isCorp;
    if (standardCta) standardCta.hidden = !isCorp;
  }

  // Runs immediately (this script is loaded, un-deferred, right after the
  // elements it targets) so the corp/default cart blocks never flash before
  // toggling. The DOMContentLoaded fallback covers pages where this script
  // loads before those elements exist.
  toggleCartBlocksForCorpUser();
  document.addEventListener('DOMContentLoaded', toggleCartBlocksForCorpUser);

  return {
    isCorpGiftsUser: isCorpGiftsUser
  };
})();
